export const CLASS_PII = 'cmc-pii';
export const CLASS_HOLDINGS = 'cmc-holdings';
